// The client's case officer is stored by user id; older clients may carry only a typed name.
// Select by id, else by an exact name, and never guess from a partial one: the picker must not
// show an officer the record is not actually linked to.

const normalize = (value) =>
  typeof value === "string" ? value.trim().replace(/\s+/g, " ").toLowerCase() : "";

export const caseOfficerOption = (users, { caseOfficerId, caseOfficer } = {}) => {
  if (!Array.isArray(users)) return null;
  if (caseOfficerId != null) {
    const byId = users.find((user) => Number(user?.id) === Number(caseOfficerId));
    if (byId) return byId;
  }
  const wanted = normalize(caseOfficer);
  if (!wanted) return null;
  return users.find((user) => normalize(user?.name) === wanted) || null;
};

export const caseOfficerFields = (user) => ({
  caseOfficer: user?.name ?? null,
  caseOfficerId: user?.id ?? null,
});
